(function () {
  'use strict';

  angular.module('app').service('TourModalService', TourModalService);

  TourModalService.$inject = ['ModalService'];

  function TourModalService(ModalService) {
    var service = {
      openTourOption: openTourOption,
      openTourListModal: openTourListModal,
    };

    return service;

    ////////////////

    // --------------------------- openTourOption -------------------------

    function openTourOption(tour, item, defaultLanguage, additionalLanguages, successCallback) {
      ModalService.showModal({
        templateUrl: './app/ajs/tours/tour-options/modals/tour-option-detail-modal.html',
        controller: TourOptionCtrl,
        controllerAs: 'vm',
        inputs: {
          tour: tour,
          item: item,
          defaultLanguage: defaultLanguage,
          additionalLanguages: additionalLanguages,
          successCallback: successCallback,
        },
      }).then(function (modal) {
        var preventModalClose = {
          backdrop: 'static',
          keyboard: false,
        };

        modal.element.modal(preventModalClose);
      });

      TourOptionCtrl.$inject = [
        '$element',
        'tour',
        'item',
        'defaultLanguage',
        'additionalLanguages',
        'successCallback',
      ];
    }

    function TourOptionCtrl(
      $element,
      tour,
      item,
      defaultLanguage,
      additionalLanguages,
      successCallback
    ) {
      var vm = this;

      vm.tourId = tour.id;
      vm.item = item;

      vm.tourName = tour.name;
      vm.optionName = item.id ? item.name : 'ADD_OPTION';

      vm.defaultLanguage = defaultLanguage;
      vm.additionalLanguages = additionalLanguages;

      // Methods
      vm.onTourOptionSaved = onTourOptionSaved;
      vm.onUpdatedItemStatus = onUpdatedItemStatus;
      vm.onTourOptionDeleted = onTourOptionDeleted;
      vm.onTourOptionCanceled = onTourOptionCanceled;

      function onTourOptionSaved(data) {
        $element.modal('hide');
        successCallback(data);
      }

      function onUpdatedItemStatus(data) {
        successCallback(data);
      }

      function onTourOptionDeleted(data) {
        successCallback(data);
      }

      function onTourOptionCanceled() {
        $element.modal('hide');
      }
    }

    // --------------------------- openTourListModal -------------------------

    function openTourListModal(websiteId) {
      // tourIds
      ModalService.showModal({
        templateUrl: './app/ajs/tours/modals/tour-list-modal.html',
        controller: TourListsModalCtrl,
        controllerAs: 'vm',
        inputs: {
          //   tourIds: tourIds,
          websiteId: websiteId,
        },
      }).then(function (modal) {
        modal.element.modal();
      });

      TourListsModalCtrl.$inject = [
        '$element',
        'UtilService',
        'AbilityService',
        '$location',
        'TourService',
        'websiteId',
      ];
    }

    function TourListsModalCtrl(
      $element,
      UtilService,
      AbilityService,
      $location,
      TourService,
      websiteId
    ) {
      var vm = this;

      vm.UtilService = new UtilService(vm);

      vm.permissions = {
        canShow: AbilityService.can('show_tour_accountadmin'),
        canCreate: AbilityService.can('create_tour_accountadmin'),
        canUpdate: AbilityService.can('update_tour_accountadmin'),
        canDestroy: AbilityService.can('destroy_tour_accountadmin'),
      };

      vm.modalTitle = 'TOURS';

      // Methods
      vm.showTour = showTour;
      vm.addContent = addContent;

      // Initializers
      getTours();

      function getTours() {
        vm.loadingItems = true;
        var params = {
          get: 'active',
          only: 'basic',
          usage: true,
          website_id: websiteId,
        };

        TourService.getTours(params).then(function (data) {
          vm.tours = data.items;
          vm.loadingItems = false;
        });
      }

      function showTour(tour) {
        if (!vm.permissions.canShow) {
          return;
        }

        $element.modal('hide'); // bootstrap fade

        setTimeout(function () {
          // Delay x sec
          $location.path(`/tours/${tour.id}`);
        }, 200);
      }

      function addContent(tour) {
        if (!vm.permissions.canCreate) {
          return;
        }

        $element.modal('hide'); // bootstrap fade

        setTimeout(function () {
          // Delay x sec
          $location.path(`/tour_contents/new`).search({ WSID: websiteId, tourId: tour.id });
        }, 200);
      }
    }
  }
})();
